import React, { createRef, Fragment } from 'react';
import API from '../../../utils/API';
import {
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Modal,
	ModalHeader,
	ModalBody
} from 'reactstrap';
import ComponentLibrary from '../../../components/codeEditor/ComponentLibrary';
import LoadingWizard from '../../../components/spinner/wizard';
import 'react-toggle/style.css';
import EditorComponentList from '../../../components/codeEditor/EditorComponent';
import InputField from '../../../components/inputs/inputField';
import SelectField from '../../../components/inputs/selectField';
import { withRouter } from 'react-router-dom';
import 'react-circular-progressbar/dist/styles.css';
import PagePreviewFrame from '../../../views/pages/components/pagePreviewFrame';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { CircularProgressbar } from 'react-circular-progressbar';
import FilesUploaderModal from '../../../components/files/filesUploaderModal';
import FileChooserPreview from '../../../components/inputs/fileChooserPreview';
import ColorField from '../../../components/inputs/colorField';
import CodeEditor from '../../../components/codeEditor/codeEditor';
import FeedbackComponent from '../../../components/email/feedbackComponent';
import * as IFrame from 'react-iframe-form';


import Joyride from 'react-joyride';
import tutorials from '../../../layouts/components/tutorials';
import moment from 'moment';



const ENV =
	process.env.NODE_ENV === 'production'
		? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;

const deviceWidthOptions = [
	{ value: 375, label: <span><i className='las la-mobile mr-10'></i> 375 px</span> },
	{ value: 768, label: <span><i className='las la-tablet mr-10'></i> 768 px</span> },
	{ value: 1200, label: <span><i className='las la-laptop mr-10'></i> 1200 px</span> },
	{ value: 1600, label: <span><i className='las la-desktop mr-10'></i> 1600 px</span> },
]

const deviceHeightOptions = [
	{ value: 667, label: <span><i className='las la-mobile mr-10'></i> 667 px</span> },
	{ value: 1024, label: <span><i className='las la-tablet mr-10'></i> 1024 px</span> },
	{ value: 800, label: <span><i className='las la-laptop mr-10'></i> 800 px</span> },
	{ value: 1080, label: <span><i className='las la-desktop mr-10'></i> 1080 px</span> },
]

const devicePresetOptions = [
	{ value: 0, label: <span><i className='las la-mobile mr-10'></i> Mobile</span> },
	{ value: 1, label: <span><i className='las la-tablet mr-10'></i> Tablet</span> },
	{ value: 2, label: <span><i className='las la-laptop mr-10'></i> Laptop</span> },
	{ value: 3, label: <span><i className='las la-desktop mr-10'></i> Desktop</span> }
]

const zoomOptions = [
	{ value: 0.25, label: <span><i className='las la-search-minus mr-10'></i> 25%</span> },
	{ value: 0.5, label: <span><i className='las la-search-minus mr-10'></i> 50%</span> },
	{ value: 0.75, label: <span><i className='las la-search-minus mr-10'></i> 75%</span> },
	{ value: 1, label: <span><i className='las la-search-minus mr-10'></i> 100%</span> },
	{ value: 1.25, label: <span><i className='las la-search-plus mr-10'></i> 125%</span> },
	{ value: 1.5, label: <span><i className='las la-search-plus mr-10'></i> 150%</span> },
	{ value: 1.75, label: <span><i className='las la-search-plus mr-10'></i> 175%</span> },
	{ value: 2, label: <span><i className='las la-search-plus mr-10'></i> 200%</span> },
]

const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result;
};

let refreshTimeInterval = null;

// Utility function to group versions by date
const groupVersionsByDate = (versions) => {
	const now = moment();
	const groups = {};

	versions.forEach((version) => {
		const versionDate = moment(version.createdAt);
		let groupKey, headerText;

		if (!version.createdAt) {
			groupKey = 'unknown';
			headerText = 'Unknown Date';
		} else if (versionDate.isSame(now, 'week')) {
			// Same week - group by day
			groupKey = `week-${versionDate.format('dddd')}`;
			headerText = versionDate.format('dddd');
		} else if (versionDate.isSame(now.clone().subtract(1, 'week'), 'week')) {
			// Last week
			groupKey = 'last-week';
			headerText = 'Last Week';
		} else {
			// Older - group by month/year
			const isCurrentYear = versionDate.isSame(now, 'year');
			if (isCurrentYear) {
				groupKey = `month-${versionDate.format('MMMM')}`;
				headerText = versionDate.format('MMMM');
			} else {
				groupKey = `month-year-${versionDate.format('MMMM-YYYY')}`;
				headerText = versionDate.format('MMMM YYYY');
			}
		}

		if (!groups[groupKey]) {
			groups[groupKey] = {
				header: headerText,
				versions: [],
				sortKey: versionDate.valueOf() // For sorting groups chronologically
			};
		}
		groups[groupKey].versions.push(version);
	});

	// Sort versions within each group by creation date (newest first)
	Object.keys(groups).forEach(key => {
		groups[key].versions.sort((a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf());
	});

	// Sort groups by date (newest first)
	const sortedGroups = Object.keys(groups).sort((a, b) => {
		if (a === 'unknown') return 1;
		if (b === 'unknown') return -1;
		return groups[b].sortKey - groups[a].sortKey;
	});

	return { groups, sortedKeys: sortedGroups };
};

class PageEditor extends React.Component {
	constructor(props) {
		super(props);
		const { match: { params } } = props;
		const orgId = params.organization || props.orgId;
		const pageId = params.page || props.pageId;
		const eventId = params.event || props.eventId;
		const REST_MAP = {
			event: {
				getPage: `Organizations/${orgId}/events/${eventId}/pages/${pageId}`,
				getAssets: `Organizations/${orgId}/events/${eventId}/assets`,
				addAssets: `Organizations/${orgId}/events/${eventId}/assets`,
				updatePage: `Organizations/${orgId}/events/${eventId}/pages/${pageId}`,
				addComponents: `Organizations/${orgId}/events/${eventId}/pages/${pageId}/editor/addComponents`,
				addGlobalComponent: `Organizations/${orgId}/events/${eventId}/pages/${pageId}/editor/addGlobalComponent`,
				addCustomComponent: `Organizations/${orgId}/events/${eventId}/pages/${pageId}/editor/addCustomComponent`,
				render: `Organizations/${orgId}/events/${eventId}/pages/render/${pageId}/`,
				getVersions: `Organizations/${orgId}/events/${eventId}/pages/${pageId}/versions/`,
				getPageFeedback: `Organizations/${orgId}/events/${eventId}/shareablePage/${pageId}`,
				postPageThread: `Organizations/${orgId}/events/${eventId}/shareablePage/${pageId}`,
				patchPageThread: `Organizations/${orgId}/events/${eventId}/shareablePage/${pageId}/thread`,
				formTypes: [
					{ label: 'Registration', value: 'registration' },
					{ label: 'Check-In', value: 'checkin' },
					{ label: 'General', value: 'general' }
				]
			},
			program: {
				getPage: `Organizations/${orgId}/programs/${params.program}/pages/${pageId}`,
				getAssets: `Organizations/${orgId}/assets`,
				addAssets: `Organizations/${orgId}/assets`,
				updatePage: `Organizations/${orgId}/programs/${params.program}/pages/${pageId}`,
				addComponents: `Organizations/${orgId}/programs/${params.program}/pages/${pageId}/editor/addComponents`,
				render: `Organizations/${orgId}/programs/${params.program}/render/${pageId}`,
				getVersions: `Organizations/${orgId}/programs/${params.program}/pages/${pageId}/versions/`,
				formTypes: [
					{ label: 'Registration', value: 'registration' },
					{ label: 'Check-In', value: 'checkin' },
					{ label: 'General', value: 'general' }
				]
			},
			account: {
				getPage: `Organizations/${orgId}/accountPages/${pageId}`,
				getAssets: `Organizations/${orgId}/assets`,
				getPrograms: `Organizations/${orgId}/programs`,
				addAssets: `Organizations/${orgId}/assets`,
				addComponents: `Organizations/${orgId}/accountPages/${pageId}/editor/addComponents`,
				addGlobalComponent: `Organizations/${orgId}/accountPages/${pageId}/editor/addGlobalComponent`,
				addCustomComponent: `Organizations/${orgId}/accountPages/${pageId}/editor/addCustomComponent`,
				updatePage: `Organizations/${orgId}/accountPages/${pageId}`,
				render: `Organizations/${orgId}/accountPages/render/${pageId}/`,
				getVersions: `Organizations/${orgId}/accountPages/${pageId}/versions/`,
				formTypes: [
					{ label: 'Program Request', value: 'programRequest' },
					{ label: 'General', value: 'general' }
				]
			}
		};

		const customFields = [
			{
				text: 'Organization Name',
				value: '{{orgName}}',
				label: 'Organization Name'
			}
		];

		this.state = {
			links: REST_MAP[props.scope],
			searchInput: '',
			pageDetails: {},
			loading: true,
			previewOpen: true,
			detailsOpen: true,
			publishOpen: false,
			deletePageOpen: false,
			page: {},
			initialPage: {},
			editedPage: {},
			editingDetails: false,
			hasPendingEdits: false,
			renderURL: REST_MAP[props.scope].render,
			userOptions: [],
			simulatedUser: { label: '', value: '' },
			simulatedSession: {},
			selectedModuleTab: 0,
			saving: false,
			componentLibraryIsOpen: false,
			componentDetailsOpen: true,
			componentDetailsExpanded: true,
			generateComponentOpen: false,
			remixComponentOpen: false,
			generationPrompt: '',
			genReferenceImage: '',
			generating: false,
			assetUploadIsOpen: false,
			frameHeight: 0,
			frameWidth: 0,
			editCount: 0,
			focusedComponent: '',
			deviceWidth: 1200,
			deviceHeight: 800,
			fontFamilies: [],
			files: [],
			horizontalViewEnabled: false,
			forms: [],
			selectedToolSection: 0,
			zoom: 1.0,
			requiredFields: {
				title: false,
				pathSlug: false
			},
			pagePaths: [],
			emailPaths: [],
			eventFeeds: [],
			pagePath: '',
			customCSSModalOpen: false,
			customFields: customFields,
			sessionOptions: [],
			componentSelected: false,
			selectedPartialIndex: null,
			parameterSelected: false,
			parameterPath: '',
			programs: [],
			isDragging: false,
			pageStylingOpen: false,
			historyOpen: false,
			runPageTutorial: false,
			versions: [],
			versionsLoading: false,
			previewedVersionId: null,
			renderOnly: false,
			feedbackPanelOpen: false,
			feedbackPanelExpanded: true,
			feedbackThreads: [],
			newThread: null
		};
		this.preview = createRef();
		this.feedbackComponentRef = React.createRef();
	}

	componentDidMount() {
		API().get(this.state.links.getPage).then((res) => {
			if (res.data) {
				const metadataOptions = [];
				res.data.customFieldLabels &&
					Object.keys(res.data.customFieldLabels).forEach((key) => {
						const layer1 = res.data.customFieldLabels[key];
						if (typeof layer1 === 'object') {
							Object.keys(layer1).forEach((key2) => {
								const layer2 = layer1[key2];
								const k2 = key2.substring(0, 1) + key2.substring(1);
								if (typeof layer2 === 'object') {
									Object.keys(layer2).forEach((key3) => {
										const layer3 = layer2[key3];
										const k3 = key3.substring(0, 1) + key3.substring(1);
										if (
											key !== '_defaultLabel' &&
											key2 !== '_defaultLabel' &&
											key3 !== '_defaultLabel'
										) {
											//metadataOptions.push(`${key}.${key2}.${key3}`);
											metadataOptions.push({
												label: `${layer1._defaultLabel} ${layer2._defaultLabel} ${layer3}`,
												value: `{{${key}${k2}${k3}}}`,
												text: `${key}${k2}${k3}`
											});
										}
									});
								} else {
									if (key !== '_defaultLabel' && key2 !== '_defaultLabel') {
										//metadataOptions.push(`${key}.${key2}`);
										metadataOptions.push({
											label: `${layer1._defaultLabel} ${layer2}`,
											value: `{{${key}${k2}}}`,
											text: `${key}${k2}`
										});
									}
								}
							});
						} else {
							if (key !== '_defaultLabel') {
								metadataOptions.push({ label: layer1, value: key, text: `{{${key}}}` });
							}
						}
					});
				this.setState({
					page: res.data,
					initialPage: res.data,
					editedPage: res.data,
					loading: false,
					userOptions: res.data.users,
					simulatedUser: res.data.users.length > 0 ? res.data.users[0] : {},
					simulatedSession:
						res.data.isSessionPage && res.data.sessions.length > 0 ? res.data.sessions[0] : {},
					sessionOptions: res.data.sessions,
					fontFamilies: res.data.fontFamilies,
					forms: res.data.forms.map((f) => {
						return { label: f.name, value: f._id };
					}),
					baseurl: res.data.baseurl,
					pagePaths: res.data.pagePaths,
					emailPaths: res.data.emailPaths,
					eventFeeds: res.data.eventFeeds,
					pagePath: res.data.url ? res.data.url.replace(res.data.baseurl, '') : '',
					customFields: metadataOptions,
					editCount: this.state.editCount + 1
				});

			}
		});

		this.state.links.getAssets &&
			API().get(this.state.links.getAssets).then((res) => {
				if (res.data) {
					this.setState({ files: res.data });
				}
			});

		this.state.links.getPrograms &&
			API().get(this.state.links.getPrograms).then((res) => {
				if (res.data) {
					const programOptions = res.data.programs.map((p) => {
						return { label: p.name, value: p._id };
					});
					this.setState({ programs: programOptions });
				}
			});

		window.addEventListener('message', (ev) => {
			if (ev.data.type == 'section-clicked' && this.state.editedPage.partials) {
				const sectionIndex = this.state.editedPage.partials.findIndex(
					(s) => `${s.file.replace('/', '_')}_${s._id}` == ev.data.sectionId
				);
				if (sectionIndex >= 0) {
					const section = this.state.editedPage.partials[sectionIndex];
					this.setState({
						focusedComponent: `#${section.file.replace('/', '_')}_${section._id}`,
						componentSelected: true,
						selectedPartialIndex: sectionIndex,
						componentDetailsOpen: true,
						componentLibraryIsOpen: false,
						pageStylingOpen: false,
						parameterPath: '',
						parameterSelected: false
					});
				}
			}

			// Feedback event handlers
			if (ev.data.type == 'thread-posted') {
				this.addNewThread(ev.data);
			}
			if (ev.data.type == 'thread-repositioned') {
				const { newThread } = this.state;
				if (newThread) {
					this.setState({ newThread: { ...newThread, coordinates: ev.data.coordinates } });
				}
			}
			if (ev.data.type == 'comment-badge-clicked') {
				console.log('Thread ID from iframe:', ev.data.threadId);
				let threadId = ev.data.threadId;
				this.selectThread(threadId);
			}

			if (typeof ev.data !== 'object') return;
			if (!ev.data.type) return;
			if (ev.data.type !== 'button-click') return;
			if (!ev.data.message) return;
			this.setState({
				message: ev.data.message
			});
		});

		// Load feedback threads
		this.loadFeedbackThreads();
	}

	refreshPage = () => {
		this.setState({ refreshTimeRemaining: 1.5 });
		if (!refreshTimeInterval) {
			refreshTimeInterval = setInterval(() => {
				if (this.state.refreshTimeRemaining > 0) {
					this.setState({ refreshTimeRemaining: this.state.refreshTimeRemaining - 0.1 });
				} else {
					this.setState({ editCount: this.state.editCount + 1 });
					clearInterval(refreshTimeInterval);
					refreshTimeInterval = null;
				}
			}, 100);
		}
	};

	// Feedback methods
	loadFeedbackThreads = async () => {
		if (this.state.links.getPageFeedback) {
			try {
				await API().get(this.state.links.getPageFeedback)
					.then((response) => {
						const feedbackThreads = response?.data?.feedbackThreads ? response.data.feedbackThreads : [];
						this.setState({ feedbackThreads: feedbackThreads });
					})
					.catch((error) => {
						console.error('Error loading feedback threads:', error);
						this.setState({ feedbackThreads: [] });
					});
			} catch (e) {
				console.log(e);
			}
		}
	}

	addNewThread = (pinnedMetadata) => {
		const { feedbackPanelOpen } = this.state;
		const authenticatedUser = this.props.account || {
			email: 'admin@simple.events',
			firstName: 'Admin',
			lastName: 'User'
		};

		const newThreadObject = {
			author: { fullName: `${authenticatedUser.firstName} ${authenticatedUser.lastName}`, email: authenticatedUser.email },
			message: '',
			counter: pinnedMetadata.commentNumber,
			comments: [],
			coordinates: {
				x: pinnedMetadata.clickPosition.x,
				y: pinnedMetadata.clickPosition.y,
			}
		};
		this.setState({ feedbackPanelOpen: true, newThread: newThreadObject });
	}

	selectThread = (threadId) => {
		if (this.feedbackComponentRef.current) {
			this.feedbackComponentRef.current.selectThread(threadId);
		}
		// Also open the feedback panel if it's not already open
		this.setState({ feedbackPanelOpen: true });
	}

	handleNewThreadOnChange = (objChange) => {
		this.setState({ newThread: { ...this.state.newThread, ...objChange } });
	}

	createNewThread = async () => {
		const { newThread } = this.state;

		// Prevent submitting empty threads
		if (!newThread?.message || newThread.message.trim().length === 0) return;

		let payload = {
			...newThread
		};

		try {
			const res = await API().post(this.state.links.postPageThread, payload);
			if (res.data) {
				const savedThread = res?.data.thread || res.data;
				const feedbackThreads = [...this.state.feedbackThreads, savedThread];
				this.setState({
					feedbackThreads: feedbackThreads,
					newThread: null,
					editCount: this.state.editCount + 1
				});
			}
		} catch (e) {
			console.log('Error creating thread:', e);
		}
	}

	patchThread = async (threadId, updatedThread, callback) => {
		const payload = {
			...updatedThread
		};

		try {
			const res = await API().patch(`${this.state.links.patchPageThread}/${threadId}`, payload);
			if (res.data) {
				const updatedThreadData = res?.data.thread || res.data;
				let feedbackThreads;

				if (payload?.deleted === true) {
					feedbackThreads = this.state.feedbackThreads.filter(thread => thread._id !== threadId);
				} else {
					feedbackThreads = this.state.feedbackThreads.map(thread => {
						if (thread._id === updatedThreadData._id) {
							return updatedThreadData;
						}
						return thread;
					});
				}

				this.setState({ feedbackThreads: feedbackThreads, editCount: this.state.editCount + 1 }, () => {
					if (callback) {
						callback();
					}
				});
			}
		} catch (e) {
			console.log('Error patching thread:', e);
		}
	}

	deleteThread = async (threadId, callback) => {
		await this.patchThread(threadId, { deleted: true }, callback);
	}

	cancelEdit = () => {
		API().get(this.state.links.getPage).then((res) => {
			if (res.data) {
				const requiredFields = this.state.requiredFields;
				Object.keys(requiredFields).forEach((key) => {
					requiredFields[key] = false;
				});
				this.setState({
					page: res.data,
					editedPage: res.data,
					editingDetails: false,
					editCount: this.state.editCount + 1,
					requiredFields: requiredFields,
					componentSelected: false,
					focusedComponent: '',
					selectedPartialIndex: 0,
					parameterPath: ''
				});
			}
		});
	};

	updatePageComponentsAPI = (selectedPartials, isCustom, isGlobal) => {
		this.setState({ saving: true });
		API()
			.post(this.state.links.addComponents, {
				partials: selectedPartials,
				isCustom: isCustom,
				isGlobal,
				isGlobal
			})
			.then((res) => {
				if (res.data) {
					const updatedPage = this.state.page;
					updatedPage.partials = res.data;
					this.setState({
						page: updatedPage,
						saving: false,
						selectedToolSection: 0
					});
					this.refreshPage();
				}
			});
	};

	updatePageComponents = (selectedPartials, isCustom, isGlobal) => {
		const updatedPage = this.state.editedPage;
		selectedPartials.forEach((partial) => {
			const newPartial = JSON.parse(JSON.stringify(partial));
			if (isGlobal) newPartial.isGlobal = true;
			updatedPage.partials.push(newPartial);
		});
		this.setState({
			editingDetails: true,
			editedPage: updatedPage,
			editCount: this.state.editCount + 1
		});
	};

	addAsGlobalComponent = (partial) => {
		API()
			.post(this.state.links.addGlobalComponent, {
				partial: partial
			})
			.then((res) => {
				if (res.data) {
					const updatedPage = this.state.page;
					updatedPage.partials = this.state.page.partials.map((p) => {
						if (p._id == res.data._id) {
							return res.data;
						}
						return p;
					});
					this.setState({ page: updatedPage, editedPage: updatedPage });
				}
			});
	};

	addAsCustomComponent = (partial) => {
		API()
			.post(this.state.links.addCustomComponent, {
				partial: partial
			})
			.then((res) => {
				this.savePage();
			});
	};

	savePage = async () => {
		const { editedPage } = this.state;
		const requiredFields = this.state.requiredFields;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!editedPage[key] || editedPage[key] === '') {
				requiredFields[key] = true;
				valid = false;
			}
		});
		if (valid) {
			this.setState({ saving: true });
			await API()
				.patch(this.state.links.updatePage, this.state.editedPage)
				.then((res) => {
					if (res.data) {
						this.setState({
							page: { ...this.state.page, ...res.data },
							editedPage: { ...this.state.page, ...res.data },
							loading: false,
							editingDetails: false,

							saving: false,
							editCount: this.state.editCount + 1,
							requiredFields: requiredFields,
							componentSelected: false,
							focusedComponent: '',
							selectedPartialIndex: 0,
							parameterPath: '',
							parameterSelected: false
						}, () => {
							this.props.updatePage(this.state.page);
							if (this.state.historyOpen) {
								this.refetchVersions();
							}
						});
					}
				})
				.catch((e) => {
					this.setState({ loading: false, editingDetails: false });
				});
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};

	updatePartialProperty = (partialIndex, property, value) => {
		const updatedPage = this.state.editedPage;
		updatedPage.partials[partialIndex][property] = value;
		this.setState({
			editingDetails: true,
			editedPage: updatedPage
		});
		this.refreshPage();
	};

	updatePartial = (partialIndex, updatedPartial) => {
		const updatedPage = this.state.editedPage;
		updatedPage.partials[partialIndex] = updatedPartial;
		this.setState({
			editingDetails: true,
			editedPage: updatedPage
		});
		this.refreshPage();
	};

	updatePartialParameters = (partialIndex, paramIndex, value) => {
		const updatedPage = this.state.editedPage;
		updatedPage.partials[partialIndex].parameters[paramIndex].value = value;
		this.setState({
			editingDetails: true,
			editedPage: updatedPage
		});
		this.refreshPage();
	};

	updatePartialOrder = (partials) => {
		this.setState({
			editingDetails: true,
			editedPage: { ...this.state.editedPage, partials: partials },
			editCount: this.state.editCount + 1
		});
	};

	duplicatePartial = (partialIndex) => {
		const updatedPage = this.state.editedPage;
		const dupPartial = JSON.parse(JSON.stringify(updatedPage.partials[partialIndex]));
		dupPartial._id = `_${dupPartial._id}`;
		updatedPage.partials.splice(partialIndex, 0, dupPartial);
		this.setState({
			editingDetails: true,
			editedPage: updatedPage,
			editCount: this.state.editCount + 1
		});
	};

	duplicateComponentContainerCard = (pIndex, element) => {
		const { selectedPartialIndex } = this.state;
		const updatedPage = this.state.editedPage;
		let dupPartial = JSON.parse(JSON.stringify(updatedPage.partials[selectedPartialIndex]));
		dupPartial.parameters[pIndex].nestedComponents.push(element);
		updatedPage.partials[selectedPartialIndex] = dupPartial;

		this.setState({
			editingDetails: true,
			editedPage: updatedPage,
			editCount: this.state.editCount + 1
		});
	};

	removePartial = (partialIndex) => {
		const updatedPage = this.state.editedPage;
		updatedPage.partials.splice(partialIndex, 1);
		this.setState({
			editingDetails: true,
			editedPage: updatedPage,
			editCount: this.state.editCount + 1,
			componentSelected: updatedPage.partials.length > 0 ? this.state.componentSelected : false,
		});
	};

	addPartial = (partial) => {
		const updatedPage = this.state.editedPage;
		updatedPage.partials.push(partial);
		this.setState({
			editingDetails: true,
			editedPage: updatedPage,
			editCount: this.state.editCount + 1
		});
	};

	generatePartial = async (prompt) => {
		//using claude to generate a partial
		const { genReferenceImage } = this.state;
		this.setState({ generating: true, generationPrompt: '' })
		const data = new FormData();
		if (prompt) {
			data.append('prompt', prompt);
		}
		if (genReferenceImage) {
			data.append('withFile', true);
			data.append('files', genReferenceImage);
		}

		API().post('platformActions/createComponent', data, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res) => {
			if (res.data) {
				console.log(res.data);
				this.addPartial(res.data);
			}
			this.setState({ generating: false });
		});
	}

	remixPartial = () => {
		const { page, selectedPartialIndex } = this.state;
		const { orgId } = this.props;
		const partialId = page.partials[selectedPartialIndex]._id;
		this.setState({ generating: true, generationPrompt: '' });
		API().post(`platformActions/remixComponent/${orgId}/${page._id}/${partialId}`, { prompt: this.state.generationPrompt }).then((res) => {
			if (res.data) {
				page.partials[selectedPartialIndex] = res.data;
				console.log(res.data);
				this.setState({ editedPage: page, editingDetails: true, editCount: this.state.editCount + 1, generating: false });
			}
		});
	}

	setDeviceWidth = (dw) => this.setState({ deviceWidth: dw });

	setDeviceHeight = (dh) => this.setState({ deviceHeight: dh });

	onDragEnd = (result) => {
		this.setState({ isDragging: false });
		// dropped outside the list
		if (!result.destination) {
			return;
		}
		switch (result.destination.droppableId) {
			case 'droppable-page-components':
				if (result.source.droppableId === 'droppable-components') {
					const editedPage = this.state.editedPage;
					const { _id, ...partial } = result.source.index;
					const draggedPartial = partial;
					draggedPartial._id = `_${this.state.editCount}`
					draggedPartial.id = _id;
					editedPage.partials.push(draggedPartial);
					this.setState({ editedPage: editedPage, editCount: this.state.editCount + 1 });
				} else if (result.source.droppableId === 'droppable-page-components') {
					const editedPage = this.state.editedPage;
					const partials = reorder(editedPage.partials, result.source.index, result.destination.index);
					editedPage.partials = partials;
					this.setState({ editedPage: editedPage, editCount: this.state.editCount + 1, editingDetails: true });
				}

				break;
			case 'droppable-page':
				if (result.source.droppableId === 'droppable-components') {
					const editedPage = this.state.editedPage;
					const { _id, ...partial } = result.source.index;
					const draggedPartial = partial;
					draggedPartial._id = `_${this.state.editCount}`
					draggedPartial.id = _id;
					editedPage.partials.push(draggedPartial);
					this.setState({ editedPage: editedPage, editCount: this.state.editCount + 1, editingDetails: true });
				}
				break;
			default:
				break;
		}
		/* const items = reorder(this.props.editedPage.partials, result.source.index, result.destination.index);
		this.props.updatePartialOrder(items); */
	}

	toggleSection = (section) => {
		const { componentDetailsOpen, componentLibraryIsOpen, pageStylingOpen, historyOpen } = this.state;

		switch (section) {
			case 'editor':
				let isPrevHistoryOpen = historyOpen;
				const editorState = {
					componentDetailsOpen: !componentDetailsOpen,
					componentLibraryIsOpen: false,
					pageStylingOpen: false,
					historyOpen: false,
					generateComponentOpen: false,
					remixComponentOpen: false,
					componentSelected: false,
					renderOnly: false,
					editCount: isPrevHistoryOpen ? this.state.editCount + 1 : this.state.editCount,
					feedbackPanelOpen: false,
				};
				if (isPrevHistoryOpen) {
					// Reverting to current when switching away from history
					editorState.editedPage = this.state.page;
					editorState.previewedVersionId = null;
					// Restore edit state if there were pending edits
					editorState.editingDetails = this.state.hasPendingEdits;
					editorState.hasPendingEdits = false;
				}
				this.setState(editorState);
				break;
			case 'library':
				const libraryState = {
					componentLibraryIsOpen: !componentLibraryIsOpen,
					componentDetailsOpen: false,
					pageStylingOpen: false,
					historyOpen: false,
					generateComponentOpen: false,
					remixComponentOpen: false,
					componentSelected: false,
					renderOnly: false,
					feedbackPanelOpen: false,
				};
				if (historyOpen) {
					// Reverting to current when switching away from history
					libraryState.editedPage = this.state.page;
					libraryState.previewedVersionId = null;
					libraryState.editCount = this.state.editCount + 1;
					// Restore edit state if there were pending edits
					libraryState.editingDetails = this.state.hasPendingEdits;
					libraryState.hasPendingEdits = false;
				}
				this.setState(libraryState);
				break;
			case 'style':
				const styleState = {
					pageStylingOpen: !pageStylingOpen,
					componentDetailsOpen: false,
					componentLibraryIsOpen: false,
					historyOpen: false,
					generateComponentOpen: false,
					remixComponentOpen: false,
					renderOnly: false,
					feedbackPanelOpen: false,
				};
				if (historyOpen) {
					// Reverting to current when switching away from history
					styleState.editedPage = this.state.page;
					styleState.previewedVersionId = null;
					styleState.editCount = this.state.editCount + 1;
					// Restore edit state if there were pending edits
					styleState.editingDetails = this.state.hasPendingEdits;
					styleState.hasPendingEdits = false;
				}
				this.setState(styleState);
				break;
			case 'history':
				const newHistoryOpen = !historyOpen;
				const baseState = {
					historyOpen: newHistoryOpen,
					componentDetailsOpen: false,
					componentLibraryIsOpen: false,
					pageStylingOpen: false,
					generateComponentOpen: false,
					remixComponentOpen: false,
					selectedPartialIndex: null,
					componentSelected: false,
					renderOnly: newHistoryOpen,
					editCount: this.state.editCount + 1,
					feedbackPanelOpen: false
				};

				if (newHistoryOpen) {
					// When opening history, preserve the current edit state and deactivate save button
					baseState.hasPendingEdits = this.state.editingDetails;
					baseState.editingDetails = false;

					if (!this.state.versionsLoading) {
						this.setState({ versionsLoading: true });
						API().get(this.state.links.getVersions).then((res) => {
							this.setState({ versions: res.data, versionsLoading: false }, () => {
								if (res.data.length > 0) {
									this.loadVersionPreview(res.data[0]);
								}
							});
						}).catch(() => {
							this.setState({ versionsLoading: false });
						});
					}
				} else {
					// When closing history, revert to current page and restore edit state
					baseState.editedPage = this.state.page;
					baseState.previewedVersionId = null;
					baseState.editingDetails = this.state.hasPendingEdits;
					baseState.hasPendingEdits = false;
				}

				this.setState(baseState);
				break;
			case 'feedback':
				let isPrevHistoryOpenFeedback = historyOpen;
				const feedbackState = {
					feedbackPanelOpen: !this.state.feedbackPanelOpen,
					componentDetailsOpen: false,
					componentLibraryIsOpen: false,
					pageStylingOpen: false,
					historyOpen: false,
					generateComponentOpen: false,
					remixComponentOpen: false,
					renderOnly: true,
					editCount: isPrevHistoryOpenFeedback ? this.state.editCount + 1 : this.state.editCount,
				};
				if (isPrevHistoryOpenFeedback) {
					// Reverting to current when switching away from history
					feedbackState.editedPage = this.state.page;
					feedbackState.previewedVersionId = null;
					feedbackState.editingDetails = this.state.hasPendingEdits;
					feedbackState.hasPendingEdits = false;
				}
				this.setState(feedbackState);
				break;
			case 'generate':
				this.setState({ generateComponentOpen: !this.state.generateComponentOpen, componentDetailsOpen: false, componentLibraryIsOpen: false, pageStylingOpen: false, historyOpen: false, remixComponentOpen: false, renderOnly: false });
				break;
			case 'remix':
				this.setState({ remixComponentOpen: !this.state.remixComponentOpen, componentDetailsOpen: false, componentLibraryIsOpen: false, pageStylingOpen: false, historyOpen: false, generateComponentOpen: false, renderOnly: false });
				break;
			default:
				break;
		}
	}
	handleJoyrideCallback = (data) => {
		const { status } = data;
		const finishedStatuses = ['finished', 'skipped'];
		if (finishedStatuses.includes(status)) {
			this.setState({ runPageTutorial: false });
		}
	};

	loadVersionPreview = (version) => {
		// Load version snapshot for preview (not saving)
		const updatedPage = { ...this.state.editedPage };
		updatedPage.partials = version.snapshot || [];
		this.setState({
			editedPage: updatedPage,
			previewedVersionId: version._id || version.versionNumber,
			editCount: this.state.editCount + 1
		});
	};

	revertToVersion = (version) => {
		// Actually revert and save the page to this version
		if (window.confirm(`Are you sure you want to revert to Version ${version.versionNumber || 'this version'}?`)) {
			const updatedPage = { ...this.state.page };
			updatedPage.partials = version.snapshot || [];
			this.setState({ editedPage: updatedPage, previewedVersionId: null }, () => {
				this.savePage();
			});
		}
	};

	refetchVersions = () => {
		API().get(this.state.links.getVersions).then((res) => {
			this.setState({
				versions: res.data,
				previewedVersionId: res.data.length > 0 ? res.data[0]._id || res.data[0].versionNumber : null
			});
		}).catch(() => {
			// Handle error silently or show notification if needed
		});
	};

	returnToCurrent = () => {
		// Return to the current unsaved state
		this.setState({
			editedPage: this.state.page,
			previewedVersionId: null,
			editCount: this.state.editCount + 1
		});
	};

	startTour = () => {
		console.log("Start Tour")
		this.setState({ runPageTutorial: true });
	};

	render() {
		const {
			loading,
			editedPage,
			renderURL,
			simulatedUser,
			simulatedSession,
			selectedModuleTab,
			saving,
			deviceWidth,
			deviceHeight,
			horizontalViewEnabled,
			zoom,
			componentLibraryIsOpen,
			componentDetailsOpen,
			componentDetailsExpanded,
			isDragging,
			editingDetails,
			pageStylingOpen,
			historyOpen,
			runPageTutorial,
			renderOnly
		} = this.state;
		const { match: { params } } = this.props;
		const eventId = params.event || this.props.eventId;
		const orgId = params.organization || this.props.orgId;
		const pageId = params.page || this.props.pageId;

		const devicePreset = devicePresetOptions.find(d => {
			const w = deviceWidthOptions[d.value].value;
			const h = deviceHeightOptions[d.value].value;
			return w === deviceWidth && h === deviceHeight;
		}) || { value: 3, label: "Custom" }

		const { isOpen, toggle } = this.props;
		return (
			<Fragment>
				<Joyride
					callback={this.handleJoyrideCallback}
					continuous
					run={runPageTutorial}
					floaterProps={{
						styles: {
							wrapper: {
								zIndex: 2000
							},
						},
					}}
					scrollOffset={64}
					scrollToFirstStep
					showProgress={false}
					hideCloseButton={false}
					showSkipButton
					steps={tutorials['PageEditDesign']}
					styles={{
						options: {
							zIndex: 2000,
						},
						buttonNext: {
							background: 'var(--primary)',
							border: 'var(--primary--border)',
							color: 'var(--white)',
							fontWeight: 600,
							padding: '10px 15px',
							fontSize: 14,
							width: 65,
							height: 30,
						},
						buttonSkip: {
							background: 'var()',
							border: 'var(--primary--border)',
							color: 'var(--primary)',
							fontWeight: 600,
							padding: '10px 15px',
							fontSize: 14,
						},
						buttonBack: {
							color: "#007bff",
						},
					}}
				/>
				<Modal isOpen={isOpen} toggle={toggle} className="fullscreen">
					<div className='modalHeader ph-20 ' style={{ borderBottom: '1px solid var(--background)' }}>
						<div className="headerContainer" style={{ maxWidth: 'unset', minHeight: 60, height: 60 }}>

							<div >
								<h2>Page Design Studio</h2>
								<h3>{editedPage.title} </h3>
							</div>
							<div className='flex aic'>
								{this.state.refreshTimeRemaining > 0 && (
									<div className='flex aic'
										style={{ width: 20, height: 20, fontSize: 20, marginRight: 20 }}
									>
										<CircularProgressbar
											value={this.state.refreshTimeRemaining}
											maxValue={1.5}
											text={this.state.refreshTimeRemaining.toFixed(0)}
											strokeWidth={12}
											counterClockwise={true}
										/>
									</div>
								)}
								<button className="neu mr-15" onClick={() => {
									if (editingDetails) {
										if (window.confirm('Are you sure you want to discard your changes?')) {
											this.props.cancelEdit();
											this.props.toggle();
										}
									} else {
										this.props.toggle();
									}
								}
								}>{editingDetails ? 'Close & Discard Changes' : 'Close'}</button>
								<button className={`neu  ${editingDetails && !this.state.historyOpen ? 'prim' : 'disabled'}`}
									onClick={this.savePage}>{this.state.historyOpen ? 'Changes Pending' : 'Save'}</button>
							</div>
						</div>
					</div>
					<ModalBody className="modalBody">
						{isOpen && <Fragment>{!loading && (<DragDropContext className="editorWorkspace" onDragEnd={this.onDragEnd} onDragStart={(e, f) => {
							this.setState({ isDragging: true });
						}}>
							<div className='flex jcsb w-100 h-100'>
								<div className="designerPreview">
									<div className='flex-sb flex aic jcc w-100 ph-20' style={{ height: 80, maxWidth: 1200 }} >
										<UncontrolledDropdown inNavbar className="mr-25">
											<DropdownToggle className="neu">
												<div className="deviceWidthButton flex-ac">
													<div className='mr-5'>
														{devicePreset.value === 0 ? (
															<i className="las la-mobile-alt" />
														) : devicePreset.value === 1 ? (
															<i className="las la-tablet" />
														) : devicePreset.value === 2 ? (
															<i className="las la-laptop" />
														) : (
															<i className="las la-crop-alt"></i>
														)}</div>

													<div className="seBlue mr-5">
														{deviceWidth}px <span className='las la-times'></span> {deviceHeight}px
													</div>
													<div className='mr-5'>at</div><div> {zoom * 100}%</div>
												</div>
											</DropdownToggle>
											<DropdownMenu left className="columnDropdown p-20" style={{ minWidth: 300 }}>
												<h5>Screen size</h5>
												<div className='p-10' >

													<SelectField label="Device Presets" options={devicePresetOptions} value={devicePreset} onChange={(e) => {
														const { value } = e;
														this.setState({
															deviceWidth: deviceWidthOptions[value].value,
															deviceHeight: deviceHeightOptions[value].value
														})
													}} />
													<div className='flex-ac'>
														<InputField
															label="Width (px)"
															value={deviceWidth}
															type="number"
															classes="mr-10"
															onChange={(e) => this.setDeviceWidth(e.target.value)}
														/>

														<InputField
															label="Height (px)"
															value={deviceHeight}
															type="number"
															onChange={(e) => this.setDeviceHeight(e.target.value)}
														/>
													</div>
												</div>
												<h5>Scale</h5>
												<div className='p-10' >

													<SelectField label="Zoom" options={zoomOptions} value={zoomOptions.find(z => z.value == zoom)} onChange={(e) => this.setState({ zoom: e.value })} />
												</div>

											</DropdownMenu>
										</UncontrolledDropdown>
									</div>
									<Droppable droppableId="droppable-page">
										{(provided, snapshot) => (<div
											ref={provided.innerRef} className="editorFrame" style={{
												transform: `scale(${zoom})`,
												pointerEvents: isDragging ? 'none' : 'auto'
											}}>
											<div
												style={{
													minWidth: `${deviceWidth}px`,
													width: `${deviceWidth}px`
												}}
												className={`pagePreviewContainer2 ${horizontalViewEnabled &&
													selectedModuleTab == 3
													? 'otter'
													: ''}`}
											>
												{!this.state.feedbackPanelOpen ?
													< PagePreviewFrame
														setPreviewDimensions={({ width, height }) => {
															this.setState({
																frameWidth: width,
																frameHeight: height
															});
														}}
														editing={this.state.editCount}
														saving={saving}
														ENV={ENV}
														renderURL={renderURL}
														simulatedUser={simulatedUser}
														simulatedSession={simulatedSession}
														focusedComponent={this.state.focusedComponent}
														pageProperties={this.state.editedPage}
														renderOnly={renderOnly}
														isSharedPage={this.state.feedbackPanelOpen}
														feedbackThreads={this.state.feedbackPanelOpen ? this.state.feedbackThreads.map(thread => ({
															_id: thread._id,
															counter: thread.counter,
															coordinates: thread.coordinates
														})) : []}
														viewOnly={true}
													/>

													: <IFrame.Form
														id="builderPreviewFrame"
														key={`template - ${this.state.editCount}`}
														name="PreviewFrame"
														config={{
															url: `${ENV}Organizations/${orgId}/events/${eventId}/pages/render/${editedPage._id}`,
															method: 'post',
															data: {
																rendering: true,
																partials: this.props.page.partials,
																...(this.props.eventId ? { eventId: this.props.eventId } : {}),
																feedbackThreads: this.state.feedbackThreads,
																eventId: eventId,
																isSharedPage: true,
																renderOnly: true,
																viewOnly: true,
																isSharedPage: true
															}
														}}
													/>}
												<div className="previewFrameOverlay" style={{ zIndex: editedPage.partials && editedPage.partials.length === 0 ? 1 : -1 }}>
													{!this.state.historyOpen && editedPage.partials.length === 0 &&
														<div>
															<div className="mb-25">
																Click the button below to add your first component.
															</div>
															<div
																className="actionButton actionSave actionOutline flex-ac"
																onClick={() =>
																	this.setState({ 
																		componentLibraryIsOpen: true,
																		componentDetailsOpen: false,
																		pageStylingOpen: false,
																		historyOpen: false,
																		feedbackPanelOpen: false,
																	})}
															>
																<i className="las la-plus" />{' '}
																<div className="">Add Component</div>
															</div>
														</div>}
													{this.state.historyOpen && this.state.versionsLoading &&  <LoadingWizard loading={true} text="Loading Version..." />}
												</div>
											</div>
										</div>)}
									</Droppable>
								</div>
								<div className={`designerPanel p-0 right ${componentDetailsOpen ? '' : 'closed'} ${componentDetailsExpanded ? 'expanded' : ''}`} style={{ overflowX: 'hidden', position: 'relative' }} >

									<div style={{ overflowX: 'hidden', padding: 25, paddingBottom: 60, maxHeight: '100%' }} className={`formInputsSection selected`}>
										<button onClick={() => this.toggleSection('editor')} style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>
										<h1 className='mb-10'>Editor</h1>
										<EditorComponentList
											togglePanel={() => this.setState({ componentDetailsOpen: !componentDetailsOpen, componentDetailsExpanded: componentDetailsOpen ? false : componentDetailsExpanded })}
											expandPanel={() => this.setState({ componentDetailsExpanded: !componentDetailsExpanded })}
											expanded={componentDetailsExpanded}
											scope={this.props.scope}
											maxCode={
												this.state.horizontalViewEnabled && selectedModuleTab == 3
											}
											event={this.props.event}
											eventCustomFields={this.props.event?.customFields?.events || []}
											editedPage={editedPage}
											updatePartial={this.updatePartial}
											updatePartialParameters={this.updatePartialParameters}
											focusedComponent={this.state.focusedComponent}
											updatePartialOrder={this.updatePartialOrder}
											focusComponent={(componentSelected, partialIndex) => {
												const partial = editedPage.partials[partialIndex];
												//get document element by name property

												const previewFrame = document.getElementsByName(
													'PreviewFrame'
												)[0];
												componentSelected
													? previewFrame.contentWindow.postMessage(
														{
															type: 'focusComponent',
															componentId: `#${partial.file.replace(
																'/',
																'_'
															)}_${partial._id?.toString()}`
														},
														'*'
													)
													: previewFrame.contentWindow.postMessage(
														{
															type: 'unfocus'
														},
														'*'
													);

												this.setState({
													focusedComponent: `#${partial.file}_${partial._id}`,
													componentSelected: componentSelected,
													selectedPartialIndex: partialIndex,
													parameterPath: '',
													parameterSelected: false
												});
											}}
											addAsCustomComponent={this.addAsCustomComponent}
											addAsGlobalComponent={this.addAsGlobalComponent}
											files={this.state.files}
											programs={this.state.programs}
											openComponentLibrary={() =>
												this.setState({ componentLibraryIsOpen: true })}
											forms={this.state.forms}
											formTypes={this.state.links.formTypes}
											pagePaths={this.state.pagePaths}
											emailPaths={this.state.emailPaths}
											eventFeeds={this.state.eventFeeds}
											duplicatePartial={this.duplicatePartial}
											duplicateComponentContainerCard={
												this.duplicateComponentContainerCard
											}
											removePartial={this.removePartial}
											fontFamilies={this.state.fontFamilies}
											customFields={this.state.customFields}
											orgId={this.props.orgId}
											links={this.state.links}
											componentSelected={this.state.componentSelected}
											selectedPartialIndex={this.state.selectedPartialIndex}
											parameterSelected={this.state.parameterSelected}
											parameterPath={this.state.parameterPath}
											setParameterSelected={(parameterSelected, parameterPath) => {
												this.setState({ parameterSelected, parameterPath });
											}}
											toggleSection={this.toggleSection}
											lockForm={this.props.lockForm}
											venue={this.props.venue}
										/>
									</div>
								</div>

								<div className={`designerPanel p-0 right ${componentLibraryIsOpen ? '' : 'closed'}`} style={{ overflowX: 'hidden', position: 'relative' }} >

									<div style={{ overflowX: 'hidden', padding: 25, paddingBottom: 60, maxHeight: '100%' }} className={`library formInputsSection selected`}>
										<button onClick={() => this.toggleSection('library')} className='Library' style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>
										<h1>Library</h1>
										{componentLibraryIsOpen && <ComponentLibrary
											orgId={orgId}
											eventId={eventId}
											ENV={ENV}
											simulatedUserId={simulatedUser.value}
											isOpen={this.state.componentLibraryIsOpen}
											updatePageComponents={this.updatePageComponents}
											addPartial={this.addPartial}
											backToComponents={() =>
												this.setState({ componentLibraryIsOpen: false })}
											togglePanel={() => this.setState({ componentLibraryIsOpen: !componentLibraryIsOpen })}
											event={this.props.event}
										/>}
									</div>
								</div>
								<div className={`designerPanel p-0 right ${pageStylingOpen ? '' : 'closed'}`} style={{ overflowX: 'hidden', position: 'relative' }} >

									<div style={{ overflowX: 'hidden', padding: 25, paddingBottom: 60, maxHeight: '100%' }} className={`formInputsSection selected`}>
										<button onClick={() => this.toggleSection('style')} style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>
										<h1 className='mb-10'>Style</h1>
										<div className="editorFileInput">
											<FileChooserPreview
												label="Background Image"
												value={editedPage.backgroundImage}
												clearFile={() =>
													this.setState({
														editingDetails: true,
														editedPage: {
															...this.state.editedPage,
															backgroundImage: ''
														},
														editCount: this.state.editCount + 1
													})}
												onClick={(e) =>
													this.setState({
														editCount: this.state.editCount + 1,
														editingDetails: true,
														editedPage: {
															...this.state.editedPage,
															backgroundImage:
																'choosing__' + editedPage.backgroundImage
														}
													})}
											/>
											<FilesUploaderModal
												links={{
													getAssets: this.state.links.getAssets,
													addAssets: this.state.links.addAssets,
												}}
												isOpen={
													editedPage.backgroundImage &&
													editedPage.backgroundImage.includes('choosing__')
												}
												toggle={() => {
													this.setState({
														editingDetails: true,
														editCount: this.state.editCount + 1,
														editedPage: {
															...this.state.editedPage,
															backgroundImage: editedPage.backgroundImage.replace(
																'choosing__',
																''
															)
														}
													});
												}}
												orgId={this.props.orgId}
												addFiles={(fileURL) => {
													this.setState({
														editCount: this.state.editCount + 1,
														editingDetails: true,
														editedPage: {
															...this.state.editedPage,
															backgroundImage: fileURL
														}
													});
												}}
											/>
										</div>

										<ColorField
											label="Background Overlay"
											value={editedPage.backgroundOverlay}
											onChange={(e) => {
												this.setState({
													editingDetails: true,
													editedPage: {
														...this.state.editedPage,
														backgroundOverlay: e
													},
													editCount: this.state.editCount + 1
												});
											}}
										/>

										<div style={{ height: 'calc(100vh - 350px)' }}>
											<p className="gray small" style={{ marginBottom: 5 }}>Custom CSS</p>
											<CodeEditor
												className={`displayedField2`}
												placeholder="Add your custom CSS here"
												content={editedPage.customCSS}
												language="css"
												style={{
													marginLeft: 0,
													width: '100%',
													height: '100%',
													minHeight: '100%'
												}}
												setContent={(c) => {
													this.setState({
														editingDetails: true,
														editedPage: {
															...this.state.editedPage,
															customCSS: c
														}
													})
													this.refreshPage()
												}

												}
											/>
										</div>
									</div>
								</div>

								<div className={`designerPanel p-0 right ${historyOpen ? '' : 'closed'}`} style={{ overflowX: 'hidden', position: 'relative' }} >

									<div style={{ overflowX: 'hidden', padding: 25, paddingBottom: 60, maxHeight: '100%' }} className={`formInputsSection selected`}>
										<button onClick={() => this.toggleSection('history')} style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>
										<h1 className='mb-10'>History</h1>
										<p className='mb-20'>
											View and manage previous versions of this page. Preview each version before deciding to revert to it. Your current changes will be preserved and you can return to the editor to continue working.
										</p>
										{this.state.versionsLoading ? (
											<LoadingWizard loading={this.state.versionsLoading} text="Loading versions..." />
										) : this.state.versions.length === 0 ? (
											<div className="explainerBox">
												<div>
													<h2 className='mb-5'>No Versions Yet</h2>
													<p>Once edits are made you will be able to see and restore previous versions, allowing you to preview each before having to apply.</p>
												</div>
											</div>
										) : (
											<div className="history-list">
												{(() => {
													const { groups, sortedKeys } = groupVersionsByDate(this.state.versions);
													return sortedKeys.map((groupKey, i) => {
														const group = groups[groupKey];
														return (
															<div key={groupKey} className="version-group mb-20">
																<h4 className="version-header mb-10" style={{ color: '#9c9c9c', paddingBottom: '5px' }}>
																	{group.header}
																</h4>
																{group.versions.map((version, index) => {
																	const isPreviewed = (version._id || version.versionNumber) === this.state.previewedVersionId;
																	const globalIndex = this.state.versions.findIndex(v => v._id === version._id);
																	return (
																		<div
																			key={version._id || index}
																			className={`history-item mb-10 p-10 rounded c-pointer `}
																			onClick={() => {
																				const versionId = version._id || version.versionNumber;
																				if (versionId !== this.state.previewedVersionId) {
																					this.loadVersionPreview(version);
																				}
																			}}
																			style={{ cursor: 'pointer', border: isPreviewed ? '1px solid var(--primary)' : '1px solid var(--border)' }}
																		>
																			<div className="flex jcsb ">
																				<div>
																					<h3 className="mb-10">{version.createdAt ? moment(version.createdAt).format('MMM D, YYYY h:mm A') : 'Unknown date'}</h3>
																					{i == 0 && index == 0 && (
																						<p className="small mb-5" style={{ color: 'var(--primary)' }}>Current Version</p>
																					)}
																					<p className="small mb-5" style={{ color: '#090505ff' }}>{`${version?.snapshot?.length || 0} Components`}</p>
																					<p className="small" style={{ color: '#9c9c9c' }}>Edited by: {version.editedBy || 'Unknown'}</p>
																				</div>
																				{globalIndex > 0 && (
																					<UncontrolledDropdown inNavbar>
																						<DropdownToggle className="columnToggle flex-ac" style={{ minHeight: '0px' }}>
																							<i className="las la-ellipsis-h" />
																						</DropdownToggle>
																						<DropdownMenu
																							right
																							className="columnDropdown p-20"
																						>
																							<h5 className='mb-10'>Options</h5>
																							<DropdownItem
																								className="dropdownItem"
																								onClick={(e) => {
																									e.stopPropagation();
																									this.revertToVersion(version);
																								}}
																							>
																								<i className="las la-undo mr-10" />Revert
																							</DropdownItem>
																						</DropdownMenu>
																					</UncontrolledDropdown>
																				)}
																			</div>
																		</div>
																	);
																})}
															</div>
														);
													});
												})()}
											</div>
										)}
									</div>
								</div>

								<div style={{ overflowX: 'hidden', position: 'relative' }} className={`designerPanel p-0 right ${this.state.feedbackPanelOpen ? '' : 'closed'} ${this.state.feedbackPanelExpanded ? 'expanded' : ''}`}>
									<div style={{ overflowX: 'hidden', overflowY: 'auto', padding: 25, paddingBottom: 60, height: 'calc(100vh - 120px)' }} className={`formInputsSection selected`}>
										<button onClick={() => this.toggleSection('feedback')} style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>
										{!this.state.loading && (
											<FeedbackComponent
												ref={this.feedbackComponentRef}
												componentSelected={this.state.focusedComponent !== ''}
												editedEmailTemplate={this.state.editedPage}
												focusedComponentIndex={this.state.focusedComponent}
												togglePanel={() => { this.setState({ feedbackPanelOpen: !this.state.feedbackPanelOpen }) }}
												expanded={this.state.feedbackPanelExpanded}
												expandPanel={() => this.setState({ feedbackPanelExpanded: !this.state.feedbackPanelExpanded })}
												focusComponent={this.focusComponent}
												updateEmailComponent={() => { }}
												links={this.state.links}
												customFields={this.state.customFields}
												newThread={this.state.newThread}
												handleNewThreadOnChange={this.handleNewThreadOnChange}
												createNewThread={this.createNewThread}
												feedbackThreads={this.state.feedbackThreads}
												patchThread={this.patchThread}
												deleteThread={this.deleteThread}
												isAdmin={true}
												authenticatedUser={{
													email: this.props.account?.email || 'admin@simple.events',
													fullName: `${this.props.account?.firstName || 'Admin'} ${this.props.account?.lastName || 'User'}`,
													_id: this.props.account?._id
												}}
											/>
										)}
									</div>
								</div>

								<div className='designerPanel side p-0' style={{ overflow: 'hidden', position: 'relative', minWidth: 100, width: 100 }} >
									<div className='flex column jcc'>
										<div className={`flex column jcc aic c-pointer ${componentDetailsOpen ? 'selectedSection' : ''} `} style={{ height: 100 }} onClick={() => {
											this.toggleSection('editor')
										}}>
											<i className='las la-edit mb-10' style={{ fontSize: 30 }}></i>
											<h5>Editor</h5></div>
										<div className={`flex column jcc aic c-pointer library ${componentLibraryIsOpen ? 'selectedSection' : ''} `} style={{ height: 100 }} onClick={() => {
											this.toggleSection('library')
										}}>
											<i className='las la-book mb-10' style={{ fontSize: 30 }}></i>
											<h5>Library</h5></div>
										<div className={`flex column jcc aic c-pointer ${pageStylingOpen ? 'selectedSection' : ''} `} style={{ height: 100 }} onClick={() => {
											this.toggleSection('style')
										}}>
											<i className='las la-brush mb-10' style={{ fontSize: 30 }}></i>
											<h5>Style</h5>
										</div>
										<div className={`flex column jcc aic c-pointer ${historyOpen ? 'selectedSection' : ''} `} style={{ height: 100 }} onClick={() => {
											this.toggleSection('history')
										}}>
											<i className='las la-history mb-10' style={{ fontSize: 30 }}></i>
											<h5>History</h5>
										</div>
										<div className={`flex column jcc aic c-pointer ${this.state.feedbackPanelOpen ? 'selectedSection' : ''} `} style={{ height: 100, position: 'relative' }} onClick={() => {
											this.toggleSection('feedback')
										}}>
											<i className='las la-comments mb-10' style={{ fontSize: 30 }}></i>
											<h5>Feedback</h5>
											{(() => {
												const openThreadsCount = this.state.feedbackThreads.filter(thread => !thread.deleted && (!thread.status || thread.status === 'open')).length;
												return openThreadsCount > 0 ? (
													<div style={{
														position: 'absolute',
														top: 10,
														right: 20,
														backgroundColor: '#FF586B',
														color: 'white',
														borderRadius: '50%',
														width: 25,
														height: 25,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														fontSize: 12,
														fontWeight: 'bold',
														border: '2px solid white'
													}}>
														{openThreadsCount}
													</div>
												) : null;
											})()}
										</div>
										{/* {<div className={`flex column jcc aic c-pointer ${generateComponentOpen ? 'selectedSection' : ''} `} style={{ height: 100 }} onClick={() => {
									this.toggleSection('generate')
								}}>
									<i className='las la-magic mb-10' style={{ fontSize: 30 }}></i>
									<h5>Generate</h5></div>} */}
									</div>

									{/* <div className='flex column jcc aic c-pointer mt-a' style={{ height: 100 }} onClick={() => {
								if (window.confirm("Are you sure you want to move to code editor? You will no longer be able to edit using drag and drop tools for this campaign.")) {

									const editedEmailTemplate = this.state.editedEmailTemplate;
									editedEmailTemplate.codeOnly = true;

									this.setState({ editedEmailTemplate, editing: true, editCount: this.state.editCount + 1 });
								}
							}}>
								<i className='las la-code mb-10' style={{ fontSize: 30 }}></i>
								<h5>Code</h5></div> */}
								</div>
							</div>
						</DragDropContext>)}
							<LoadingWizard text="Setting up page" loading={loading} />
						</Fragment>}
					</ModalBody>
				</Modal>
			</Fragment>
		)
	}
}

export default withRouter(PageEditor);
